import { z } from "zod";
import { AgencyIdSchema, ProjectIdSchema } from "../primitives/ids.js";
export const CareAlertSeveritySchema = z.enum(["LOW", "MEDIUM", "HIGH", "CRITICAL"]);
export const CareAlertPolicyV1Schema = z
    .object({
    schemaVersion: z.literal("care-alert-policy.v1.0"),
    policyId: z.string(),
    agencyId: AgencyIdSchema,
    projectId: ProjectIdSchema,
    ownerUserId: z.string(),
    severity: CareAlertSeveritySchema,
    suppressionMinutes: z.number().int().nonnegative(),
    deliveryChannel: z.enum(["IN_APP", "EMAIL_STUB"]),
    updatedAt: z.string().datetime(),
})
    .strict();
export const CareAlertRecordV1Schema = z
    .object({
    schemaVersion: z.literal("care-alert-record.v1.0"),
    alertId: z.string(),
    policyId: z.string(),
    agencyId: AgencyIdSchema,
    projectId: ProjectIdSchema,
    severity: CareAlertSeveritySchema,
    summary: z.string(),
    suppressed: z.boolean(),
    deliveryProofId: z.string().nullable(),
    createdAt: z.string().datetime(),
})
    .strict();
//# sourceMappingURL=care-alert-policy.js.map